import { getElectronAPI } from "@/plugins/desktop";
import ApiOfflineService from "./ApiOfflineService";
import BalancaEtiquetaService from "./BalancaEtiquetaService";

const STORAGE_KEY = "configuracoes_gerais_pdv";

const isTrue = (value) =>
  value === true || value === 1 || value === "1" || value === "true";

const DEFAULTS = Object.freeze({
  usar_codigo_balanca: false,
  balanca_etiqueta_tipo: "peso",
  balanca_tamanho_codigo_produto: 4,
  balanca_casas_decimais: 3,
  solicita_senha_adm: false,
  abertura_caixa: true,
  fechamento_as_cegas: false,
});

function unwrap(payload) {
  const value = payload?.data ?? payload ?? {};
  return Array.isArray(value) ? (value[0] || {}) : value;
}

function normalizar(config = {}) {
  const merged = { ...DEFAULTS, ...unwrap(config) };
  const aberturaCaixa = isTrue(merged.abertura_caixa);
  return {
    ...merged,
    usar_codigo_balanca: isTrue(merged.usar_codigo_balanca),
    solicita_senha_adm: isTrue(merged.solicita_senha_adm),
    abertura_caixa: aberturaCaixa,
    fechamento_as_cegas: aberturaCaixa && isTrue(merged.fechamento_as_cegas),
    balanca_tamanho_codigo_produto: Number(merged.balanca_tamanho_codigo_produto) || 4,
    balanca_casas_decimais: Number(merged.balanca_casas_decimais) || 3,
  };
}

const ConfiguracaoGeralPdvDesktopService = {
  defaults: DEFAULTS,
  normalizar,

  async carregarLocal() {
    try {
      const raw = await getElectronAPI()?.config?.get(STORAGE_KEY);
      return normalizar(raw ? JSON.parse(raw) : {});
    } catch (_) {
      return normalizar();
    }
  },

  async salvarLocal(config = {}) {
    const normalizada = normalizar(config);
    const api = getElectronAPI();
    if (api?.config) {
      await api.config.set(STORAGE_KEY, JSON.stringify(normalizada));
    }

    const balancaLocal = await BalancaEtiquetaService.carregarLocal();
    await BalancaEtiquetaService.salvarLocal(
      BalancaEtiquetaService.mesclar(balancaLocal, normalizada)
    );
    return normalizada;
  },

  async sincronizar() {
    const response = await ApiOfflineService.post("configuracoesgerais/find");
    return this.salvarLocal(response);
  },
};

export default ConfiguracaoGeralPdvDesktopService;
